// store/agingReport.slice.ts

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AgingReportState {
  summary: any | null;
  table: any[];

  paginator: any | null;

  page: number;
  size: number;
  sort: string;

  loading: boolean;
  error: string | null;
}

const initialState: AgingReportState = {
  summary: null,
  table: [],

  paginator: null,

  page: 0,
  size: 10,
  sort: "customerName,asc",

  loading: false,
  error: null,
};

const agingReportSlice = createSlice({
  name: "agingReport",
  initialState,
  reducers: {
    setAgingLoading(
      state,
      action: PayloadAction<boolean>
    ) {
      state.loading = action.payload;
    },

    setAgingError(
      state,
      action: PayloadAction<string | null>
    ) {
      state.error = action.payload;
    },

    /**
     * 📊 resumen superior
     */
    setAgingSummary(
      state,
      action: PayloadAction<any>
    ) {
      state.summary = action.payload;
    },

    /**
     * 📄 tabla paginada
     */
    setAgingTable(
      state,
      action: PayloadAction<{
        content: any[];
      }>
    ) {
      state.table = action.payload.content;
      state.paginator = action.payload;
      state.loading = false;
    },

    clearAgingReport(state) {
      state.summary = null;
      state.table = [];
      state.paginator = null;
      state.error = null;
    },

    setPage(
      state,
      action: PayloadAction<number>
    ) {
      state.page = action.payload;
    },

    setSize(
      state,
      action: PayloadAction<number>
    ) {
      state.size = action.payload;
    },

    setSort(
      state,
      action: PayloadAction<string>
    ) {
      state.sort = action.payload;
    },
  },
});

export const {
  setAgingLoading,
  setAgingError,
  setAgingSummary,
  setAgingTable,
  clearAgingReport,
  setPage,
  setSize,
  setSort,
} = agingReportSlice.actions;

export default agingReportSlice.reducer;